/**
 * Traditional Chinese (zh-TW) Translations
 */

import common from './common.json'
import landing from './landing.json'
import billing from './billing.json'
import guidance from './guidance.json'

export default {
  common,
  landing,
  billing,
  guidance,
} as const
